// extracted by mini-css-extract-plugin
export default {"UtilityBoxItem":"utility-box-item_UtilityBoxItem__2xK1h","childWrapper":"utility-box-item_childWrapper__ZSO6Y","icon":"utility-box-item_icon__36C8Y"};